import React from 'react';
import { Sidebar, Topbar, MobileTab } from './shell.jsx';
import { TodayView } from './today.jsx';
import { ProjectsView, ProjectDetail } from './projects.jsx';
import {
  CalendarView,
  BlocksView,
  BrainDumpView,
  AIOrganizerView,
  ReflectionView,
  Dashboard,
  SettingsView,
  LoginView,
} from './extras.jsx';

export default function App() {
  const [view, setView] = React.useState('dashboard');
  const [theme, setTheme] = React.useState('dark');
  const [project, setProject] = React.useState(null);

  React.useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const openProject = (p) => {
    setProject(p);
    setView('project');
  };

  if (view === 'login') {
    return <LoginView onSignIn={() => setView('today')} />;
  }

  return (
    <div className="app" data-screen-label={'01 ' + view}>
      <Sidebar view={view} setView={setView} />
      <div className="main">
        <Topbar view={view} theme={theme} setTheme={setTheme} />
        <div className="content">
          {view === 'today' && <TodayView />}
          {view === 'dashboard' && <Dashboard onOpen={openProject} />}
          {view === 'projects' && <ProjectsView onOpen={openProject} />}
          {view === 'project' && (
            <ProjectDetail project={project} onBack={() => setView('projects')} />
          )}
          {view === 'calendar' && <CalendarView />}
          {view === 'blocks' && <BlocksView />}
          {view === 'braindump' && <BrainDumpView />}
          {view === 'ai' && <AIOrganizerView />}
          {view === 'reflection' && <ReflectionView />}
          {view === 'settings' && (
            <SettingsView theme={theme} setTheme={setTheme} />
          )}
        </div>
        <div className="signout-rail">
          <button
            className="btn btn--ghost btn--sm"
            onClick={() => setView('login')}
          >
            Show sign-in screen →
          </button>
        </div>
        <MobileTab view={view} setView={setView} />
      </div>
    </div>
  );
}
